import { jsxs as a, jsx as C } from "react/jsx-runtime";
const i = ({
  width: l = 202,
  height: L = 202
}) => /* @__PURE__ */ a(
  "svg",
  {
    width: l,
    height: L,
    viewBox: "0 0 209 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "no-coupons-icon",
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M32.1949 73.751C31.5424 75.2338 30.8231 76.8353 30.1928 78.3997C29.5625 79.9641 28.91 81.573 28.339 83.1744C27.1675 86.2964 26.2282 89.5007 25.5287 92.761L25.3136 93.9473L25.2395 94.3922C25.2395 94.5182 25.2395 94.6813 25.195 94.8296C25.1668 95.5515 25.1817 96.2744 25.2395 96.9945C25.3804 98.5589 25.6325 100.235 25.981 101.91C26.6039 105.269 27.3973 108.731 28.2056 112.142L24.4016 113.625C22.6283 110.393 21.1182 107.023 19.8857 103.549C19.2364 101.74 18.7112 99.89 18.3137 98.0103C18.091 96.9703 17.9521 95.9141 17.8984 94.8518C17.8984 94.5553 17.8984 94.2735 17.8984 93.9547C17.8984 93.6359 17.8984 93.28 17.9503 93.0724L18.0986 91.5896C18.3202 89.6799 18.6595 87.7856 19.1145 85.9177C19.5298 84.0641 20.0637 82.2625 20.5976 80.4831C21.1315 78.7037 21.7988 76.9539 22.5033 75.2338C22.8518 74.3738 23.2448 73.5211 23.5859 72.6685C23.927 71.8159 24.3274 71.0003 24.802 70.0883L32.1949 73.751Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M28.0043 111.141L30.8962 113.966L24.5859 116.931C24.5859 116.931 23.0584 114.255 24.1188 111.838L28.0043 111.141Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M33.2324 118.169L27.9009 120.349L24.5938 116.902L30.8967 113.966L33.2324 118.169Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.4",
          d: "M141.235 115.13C130.743 113.952 120.836 109.69 112.766 102.883C104.697 96.0765 98.8264 87.0303 95.8978 76.8882C92.9693 66.7461 93.1138 55.9635 96.3132 45.9035C99.5127 35.8436 105.623 26.9579 113.873 20.3698C122.122 13.7818 132.14 9.78715 142.659 8.8909C153.179 7.99466 163.728 10.2371 172.973 15.3346C182.219 20.4322 189.745 28.156 194.6 37.5297C199.456 46.9034 201.423 57.5061 200.253 67.9974C199.475 74.9678 197.331 81.7167 193.944 87.8584C190.557 94.0001 185.992 99.4142 180.512 103.791C175.031 108.168 168.741 111.423 162.002 113.368C155.262 115.314 148.206 115.912 141.235 115.13Z",
          fill: "#BABDE4"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.4",
          d: "M180.075 20.0201L98.8788 84.8871C98.5377 84.1457 98.2041 83.4043 97.8926 82.6628C95.857 77.8216 94.5549 72.7038 94.0293 67.4785L164.162 11.4492C169.92 13.3697 175.303 16.2692 180.075 20.0201Z",
          fill: "#FAFAFA"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.4",
          d: "M198.814 48.4388L122.475 109.421C115.223 105.641 108.938 100.242 104.107 93.6433L187.462 27.0488C192.835 33.2152 196.719 40.5334 198.814 48.4388Z",
          fill: "#FAFAFA"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M87.0892 41.677L86.3848 41.4398C87.6048 37.8402 89.1382 34.3545 90.9673 31.0228L91.6125 31.3787C89.8075 34.6731 88.2939 38.119 87.0892 41.677ZM96.0912 24.3722L95.4906 23.9348C101.585 15.696 109.56 9.03328 118.752 4.50213L119.086 5.16941C109.998 9.65378 102.114 16.2453 96.0912 24.3945V24.3722ZM177.354 6.18515C174.931 4.88563 172.424 3.74874 169.85 2.78203L170.117 2.08509C172.716 3.07448 175.248 4.2336 177.695 5.55495L177.354 6.18515Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.3",
          d: "M87.0892 41.677L86.3848 41.4398C87.6048 37.8402 89.1382 34.3545 90.9673 31.0228L91.6125 31.3787C89.8075 34.6731 88.2939 38.119 87.0892 41.677ZM96.0912 24.3722L95.4906 23.9348C101.585 15.696 109.56 9.03328 118.752 4.50213L119.086 5.16941C109.998 9.65378 102.114 16.2453 96.0912 24.3945V24.3722ZM177.354 6.18515C174.931 4.88563 172.424 3.74874 169.85 2.78203L170.117 2.08509C172.716 3.07448 175.248 4.2336 177.695 5.55495L177.354 6.18515Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M202.381 34.8115C195.514 20.5727 183.431 9.52183 168.637 3.94983C153.842 -1.62217 137.47 -1.28796 122.915 4.88316C108.36 11.0543 96.7382 22.589 90.459 37.0961C84.1797 51.6033 83.7245 67.9701 89.1878 82.8037C84.2344 84.5386 79.3404 86.3996 74.476 88.3199C67.4613 91.1027 60.5108 94.0091 53.6245 97.039C46.7432 100.086 39.8916 103.193 33.1067 106.44C29.7031 108.034 26.344 109.717 22.9553 111.348C21.1924 112.106 19.5952 113.202 18.2541 114.574C17.5283 115.333 16.8892 116.171 16.3483 117.072C15.6885 118.138 15.1888 119.294 14.8653 120.505C14.3073 122.687 14.5486 124.996 15.5455 127.016C16.5425 129.035 18.2292 130.631 20.3006 131.515C21.451 131.998 22.6646 132.312 23.9044 132.449C24.9516 132.568 26.0087 132.568 27.0559 132.449C28.9588 132.218 30.7979 131.616 32.469 130.677C35.8281 128.979 39.2094 127.341 42.5462 125.599C49.2199 122.195 55.8936 118.644 62.4857 115.041C69.0778 111.437 75.6773 107.664 82.1137 103.793C86.5628 101.102 91.0564 98.3513 95.461 95.4746C103.919 108.825 117.19 118.41 132.523 122.244C147.857 126.078 164.078 123.866 177.825 116.068C191.572 108.269 201.792 95.481 206.366 80.3537C210.94 65.2264 209.519 48.9193 202.396 34.8115H202.381ZM168.671 105.64C160.054 109.893 150.369 111.495 140.84 110.245C131.312 108.994 122.368 104.947 115.14 98.6145C107.913 92.282 102.725 83.9488 100.233 74.6686C97.7419 65.3883 98.0585 55.5778 101.143 46.4774C104.228 37.3771 109.942 29.3956 117.563 23.5422C125.184 17.6889 134.37 14.2265 143.959 13.5928C153.549 12.9592 163.11 15.1827 171.436 19.9824C179.761 24.782 186.476 31.9422 190.731 40.5575C193.558 46.279 195.229 52.5011 195.65 58.8685C196.071 65.2359 195.233 71.6238 193.184 77.6675C191.136 83.7111 187.917 89.292 183.711 94.0915C179.505 98.891 174.394 102.815 168.671 105.64Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.3",
          d: "M202.381 34.8115C195.514 20.5727 183.431 9.52183 168.637 3.94983C153.842 -1.62217 137.47 -1.28796 122.915 4.88316C108.36 11.0543 96.7382 22.589 90.459 37.0961C84.1797 51.6033 83.7245 67.9701 89.1878 82.8037C84.2344 84.5386 79.3404 86.3996 74.476 88.3199C67.4613 91.1027 60.5108 94.0091 53.6245 97.039C46.7432 100.086 39.8916 103.193 33.1067 106.44C29.7031 108.034 26.344 109.717 22.9553 111.348C21.1924 112.106 19.5952 113.202 18.2541 114.574C17.5283 115.333 16.8892 116.171 16.3483 117.072C15.6885 118.138 15.1888 119.294 14.8653 120.505C14.3073 122.687 14.5486 124.996 15.5455 127.016C16.5425 129.035 18.2292 130.631 20.3006 131.515C21.451 131.998 22.6646 132.312 23.9044 132.449C24.9516 132.568 26.0087 132.568 27.0559 132.449C28.9588 132.218 30.7979 131.616 32.469 130.677C35.8281 128.979 39.2094 127.341 42.5462 125.599C49.2199 122.195 55.8936 118.644 62.4857 115.041C69.0778 111.437 75.6773 107.664 82.1137 103.793C86.5628 101.102 91.0564 98.3513 95.461 95.4746C103.919 108.825 117.19 118.41 132.523 122.244C147.857 126.078 164.078 123.866 177.825 116.068C191.572 108.269 201.792 95.481 206.366 80.3537C210.94 65.2264 209.519 48.9193 202.396 34.8115H202.381ZM168.671 105.64C160.054 109.893 150.369 111.495 140.84 110.245C131.312 108.994 122.368 104.947 115.14 98.6145C107.913 92.282 102.725 83.9488 100.233 74.6686C97.7419 65.3883 98.0585 55.5778 101.143 46.4774C104.228 37.3771 109.942 29.3956 117.563 23.5422C125.184 17.6889 134.37 14.2265 143.959 13.5928C153.549 12.9592 163.11 15.1827 171.436 19.9824C179.761 24.782 186.476 31.9422 190.731 40.5575C193.558 46.279 195.229 52.5011 195.65 58.8685C196.071 65.2359 195.233 71.6238 193.184 77.6675C191.136 83.7111 187.917 89.292 183.711 94.0915C179.505 98.891 174.394 102.815 168.671 105.64Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M52.6914 47.2746C52.6914 47.7121 52.9213 48.0679 53.2105 48.0679C53.4997 48.0679 53.7295 47.7121 53.7295 47.2746C53.7295 46.8372 53.4997 46.4813 53.2105 46.4813C52.9213 46.4813 52.6914 46.8668 52.6914 47.2746Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M52.8984 48.0681C53.4233 49.4109 54.1293 50.6756 54.9969 51.8271C54.697 52.0417 54.3537 52.188 53.9912 52.2559C53.6287 52.3238 53.2557 52.3115 52.8984 52.2201V48.0681Z",
          fill: "#DE5753"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M51.1561 44.8356C51.1147 44.8356 51.0739 44.8263 51.0366 44.8083C50.9994 44.7903 50.9667 44.7642 50.941 44.7318C50.9024 44.6752 50.887 44.6059 50.898 44.5383C50.9091 44.4707 50.9457 44.4099 51.0003 44.3685C51.3269 44.1209 51.7085 43.9558 52.1126 43.8874C52.5167 43.819 52.9314 43.8492 53.3213 43.9756C53.3563 43.9851 53.3889 44.0019 53.4171 44.0248C53.4452 44.0477 53.4682 44.0763 53.4846 44.1087C53.501 44.141 53.5104 44.1765 53.5123 44.2127C53.5141 44.249 53.5083 44.2852 53.4953 44.3191C53.4823 44.3529 53.4623 44.3837 53.4366 44.4094C53.411 44.435 53.3802 44.455 53.3463 44.4681C53.3125 44.4811 53.2762 44.4869 53.24 44.4851C53.2038 44.4833 53.1683 44.4739 53.1359 44.4575C52.8262 44.3625 52.4982 44.3432 52.1795 44.4013C51.8608 44.4593 51.5607 44.593 51.3044 44.7911C51.2604 44.8203 51.2088 44.8357 51.1561 44.8356Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M37.7114 50.5741C38.4529 54.5555 39.2686 61.8585 36.4805 64.5202C36.4805 64.5202 37.5705 68.561 44.9783 68.561C53.135 68.561 48.8638 64.5202 48.8638 64.5202C44.4147 63.4526 44.5408 60.1607 45.312 57.0615L37.7114 50.5741Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M33.1514 66.6184C34.0338 65.2468 32.5508 61.9178 32.5508 61.9178C32.5508 61.9178 45.6608 58.6184 51.022 63.6823C52.1343 64.7278 50.9034 66.2699 50.9034 66.2699L33.1514 66.6184Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.1",
          d: "M33.1514 66.6184C34.0338 65.2468 32.5508 61.9178 32.5508 61.9178C32.5508 61.9178 45.6608 58.6184 51.022 63.6823C52.1343 64.7278 50.9034 66.2699 50.9034 66.2699L33.1514 66.6184Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M11.4626 217.891C10.773 217.891 9.6681 216.742 9.34183 216.312C9.32781 216.291 9.32031 216.266 9.32031 216.241C9.32031 216.216 9.32781 216.191 9.34183 216.171C9.3538 216.15 9.37113 216.133 9.39201 216.121C9.41288 216.109 9.43653 216.103 9.46047 216.104C9.54204 216.104 11.3588 216.267 11.8556 216.912C11.9096 216.98 11.9482 217.059 11.9687 217.144C11.9892 217.228 11.991 217.316 11.9742 217.401C11.9678 217.512 11.9272 217.617 11.8581 217.704C11.7891 217.79 11.6949 217.853 11.5886 217.883L11.4626 217.891ZM9.74225 216.408C10.2836 217.031 11.1511 217.735 11.5219 217.646C11.5219 217.646 11.6702 217.609 11.7147 217.372C11.7244 217.322 11.7228 217.271 11.71 217.222C11.6972 217.174 11.6734 217.128 11.6405 217.09C11.0912 216.674 10.4303 216.431 9.74225 216.393V216.408Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M9.82283 216.393C9.6897 216.407 9.55554 216.407 9.42241 216.393C9.39897 216.391 9.37659 216.383 9.35811 216.368C9.33963 216.354 9.32588 216.334 9.3186 216.312C9.30817 216.291 9.30273 216.268 9.30273 216.245C9.30273 216.222 9.30817 216.199 9.3186 216.178C9.3705 216.134 10.4605 214.999 11.2836 214.999C11.3821 214.997 11.48 215.016 11.5707 215.054C11.6615 215.092 11.7431 215.15 11.8101 215.222C11.8839 215.283 11.9344 215.369 11.9533 215.463C11.9722 215.557 11.9583 215.655 11.9139 215.741C11.6989 216.156 10.5643 216.393 9.82283 216.393ZM9.72643 216.134C10.4679 216.134 11.5432 215.904 11.7211 215.578C11.7211 215.578 11.773 215.481 11.6544 215.363C11.6112 215.316 11.5583 215.279 11.4994 215.254C11.4405 215.23 11.377 215.219 11.3133 215.222C10.7054 215.361 10.1529 215.679 9.72643 216.134Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M60.395 234.721C59.833 234.717 59.2723 234.665 58.7192 234.565C58.6917 234.56 58.667 234.545 58.6494 234.524C58.6317 234.502 58.6223 234.475 58.6228 234.447C58.6187 234.421 58.6221 234.395 58.6326 234.371C58.6431 234.347 58.6603 234.327 58.6821 234.313C58.7637 234.269 60.662 233.179 61.5741 233.431C61.6586 233.45 61.7384 233.486 61.8085 233.537C61.8787 233.588 61.9376 233.653 61.9819 233.727C62.04 233.81 62.0712 233.908 62.0712 234.009C62.0712 234.11 62.04 234.209 61.9819 234.291C61.7669 234.625 61.0921 234.721 60.395 234.721ZM59.1419 234.373C60.1503 234.521 61.5296 234.513 61.7817 234.158C61.8188 234.113 61.8484 234.031 61.7817 233.876C61.725 233.783 61.6346 233.717 61.5296 233.69C60.9512 233.542 59.8018 234.031 59.1419 234.373Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M58.7481 234.573C58.7239 234.58 58.6982 234.58 58.6739 234.573C58.6534 234.56 58.6374 234.54 58.6281 234.518C58.6188 234.495 58.6167 234.47 58.622 234.447C58.6723 233.675 58.9685 232.94 59.4674 232.348C59.5682 232.261 59.6867 232.197 59.8147 232.16C59.9426 232.123 60.0771 232.114 60.2089 232.133C60.5648 232.133 60.6686 232.348 60.6909 232.489C60.7873 233.105 59.4896 234.284 58.8297 234.58L58.7481 234.573ZM60.0754 232.348C59.9123 232.347 59.7542 232.405 59.6305 232.512C59.2112 232.98 58.9515 233.569 58.889 234.195C59.5564 233.787 60.4462 232.867 60.372 232.497C60.372 232.497 60.372 232.371 60.1199 232.348H60.0754Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M52.7578 234.439H58.208L58.7493 221.828H53.2991L52.7578 234.439Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M4.22461 212.79L8.77754 215.77L18.8325 207.281L14.2722 204.293L4.22461 212.79Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M9.5266 215.489L4.79571 211.611C4.71213 211.542 4.60729 211.505 4.4991 211.505C4.39091 211.505 4.28608 211.542 4.20249 211.611L0.302102 214.673C0.207872 214.748 0.131774 214.843 0.0794687 214.952C0.0271635 215.06 0 215.179 0 215.299C0 215.42 0.0271635 215.539 0.0794687 215.647C0.131774 215.756 0.207872 215.851 0.302102 215.926C1.97794 217.253 2.86034 217.817 4.94401 219.522C6.22684 220.567 9.39312 223.77 11.1802 225.216C12.9672 226.662 14.606 225.105 14.0128 224.356C11.3507 220.982 10.3052 218.098 10.0012 216.311C9.94863 215.988 9.77986 215.696 9.5266 215.489Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M58.1705 233.809H52.2384C52.1302 233.81 52.0253 233.846 51.9406 233.914C51.8558 233.981 51.7962 234.075 51.7712 234.18L50.696 239.021C50.669 239.139 50.669 239.261 50.6961 239.378C50.7232 239.495 50.7767 239.605 50.8524 239.699C50.9282 239.792 51.0242 239.867 51.1333 239.918C51.2424 239.969 51.3616 239.995 51.482 239.993C53.625 239.956 56.7246 239.83 59.4237 239.83C62.5752 239.83 65.304 240 68.9967 240C71.2213 240 71.859 237.739 70.9172 237.539C66.6609 236.604 63.1758 236.508 59.4978 234.232C59.1032 233.971 58.6436 233.824 58.1705 233.809Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M25.7433 66.1438C21.0198 68.3681 18.3281 83.2707 18.3281 83.2707L29.8736 87.8749C31.5636 83.7489 32.9296 79.4976 33.9594 75.1595C35.5462 68.2939 30.578 63.8454 25.7433 66.1438Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M31.8686 74.5443C29.0137 77.4358 27.7087 83.1003 27.1377 86.7852L29.9036 87.8899C31.5455 83.881 32.884 79.7545 33.9078 75.5452C33.6631 73.9734 33.055 73.3432 31.8686 74.5443Z",
          fill: "#203048"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M57.244 66.0402C57.244 66.0402 63.0427 72.5944 57.5702 113.12H28.436C28.2358 108.672 31.0461 86.8371 26.7305 65.7659C29.9502 65.1417 33.2076 64.7305 36.4814 64.5351C40.6056 64.2902 44.7407 64.2902 48.8648 64.5351C51.6926 64.8196 54.494 65.3228 57.244 66.0402Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M59.9059 81.7732L54.9971 73.3136C54.0495 77.2607 53.6626 81.3216 53.8477 85.3766C53.9812 88.2829 56.6433 99.0484 59.0384 100.62C59.6739 94.3586 59.9635 88.0667 59.9059 81.7732Z",
          fill: "#203048"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M60.5876 71.8307C61.3291 75.434 62.0707 79.1263 62.8641 82.7444C63.6575 86.3625 64.4806 89.9955 65.4372 93.5024C65.6819 94.3699 65.9117 95.2596 66.1787 96.09L66.3789 96.7276L66.4753 97.0464V97.0094C66.4234 96.9426 66.3641 96.9352 66.4086 97.0094C66.7133 97.3422 67.1029 97.5857 67.5357 97.7137C68.2367 97.9745 68.9585 98.1754 69.6935 98.3143C73.1993 98.8698 76.7489 99.1007 80.2972 99.0038L81.0016 103.037C80.008 103.356 79.0811 103.586 78.1023 103.816C77.1235 104.045 76.1595 104.238 75.1733 104.387C73.1329 104.726 71.064 104.865 68.9965 104.802C67.8472 104.771 66.7042 104.622 65.5855 104.357C64.163 104.046 62.8263 103.426 61.6702 102.54C60.9152 101.931 60.292 101.174 59.8387 100.316C59.72 100.094 59.6162 99.8416 59.5198 99.6266L59.3864 99.2781L59.112 98.5367C58.7338 97.5951 58.4224 96.6683 58.0813 95.7415C56.8281 92.0344 55.7826 88.2902 54.8631 84.5535C53.9436 80.8167 53.1502 77.0874 52.4902 73.2542L60.5876 71.8307Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M49.9692 70.0142C48.4342 74.9892 54.6556 89.825 54.6556 89.825L67.0464 86.711C67.0464 86.711 66.5718 79.0002 63.7466 72.8835C59.4903 63.6602 51.8081 64.0458 49.9692 70.0142Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M80.1929 99.0037L86.3623 98.848L83.3963 105.269C83.3963 105.269 80.8825 105.602 78.8211 102.214L76.6484 99.6191L79.1474 99.1224C79.4913 99.0499 79.8414 99.0102 80.1929 99.0037Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M90.2555 100.042L86.7259 105.365L83.3965 105.269L86.3626 98.848L90.2555 100.042Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M58.7485 221.828L58.4668 228.33H53.0166L53.2984 221.828H58.7485Z",
          fill: "#CE6F64"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M14.2731 204.293L18.8334 207.281L13.6428 211.655L9.08984 208.675L14.2731 204.293Z",
          fill: "#CE6F64"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M38.0531 46.3332C38.3794 51.7233 38.2978 54.904 41.0192 57.6695C45.1124 61.8438 51.7787 59.3748 53.0689 53.9624C54.2331 49.1135 53.5064 41.1062 48.2268 38.9561C47.0618 38.4859 45.7965 38.3194 44.5496 38.4721C43.3027 38.6249 42.115 39.0919 41.098 39.8293C40.081 40.5668 39.2681 41.5504 38.7355 42.6881C38.2029 43.8257 37.9681 45.08 38.0531 46.3332Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M31.7052 45.3841C33.0473 50.2997 36.2062 55.9642 40.292 56.3275C45.3639 56.7723 47.6552 51.5305 48.3226 46.1181C51.3628 44.0347 49.7686 41.7437 52.8162 41.4545C56.7314 41.0838 55.4783 33.9217 50.3247 32.7725C50.3247 32.7725 52.0524 35.9977 48.4264 34.3666C44.978 32.7279 41.1469 32.0639 37.3481 32.4463C37.3481 32.4463 41.9752 34.7595 37.4519 35.7901C32.9287 36.8207 31.5791 39.6084 33.6628 41.2914C33.6628 41.2988 30.8227 42.1515 31.7052 45.3841Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M45.2302 47.2302C45.3298 48.5701 45.8695 49.8395 46.7652 50.841C47.9516 52.1533 49.1899 51.3377 49.3976 49.7437C49.5904 48.3127 49.1974 45.9031 47.744 45.1765C46.2906 44.4499 45.1338 45.6139 45.2302 47.2302Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M47.2324 113.12C47.2324 113.12 52.5417 151.563 48.3595 166.97C41.7304 191.363 16.3852 211.952 16.3852 211.952L7.79102 206.317C7.79102 206.317 29.3766 188.931 32.0164 168.505C34.3893 150.169 28.4349 127.993 28.4349 113.113L47.2324 113.12Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.1",
          d: "M47.2324 113.12C47.2324 113.12 52.5417 151.563 48.3595 166.97C41.7304 191.363 16.3852 211.952 16.3852 211.952L7.79102 206.317C7.79102 206.317 29.3766 188.931 32.0164 168.505C34.3893 150.169 28.4349 127.993 28.4349 113.113L47.2324 113.12Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M49.4276 135.096C48.0142 133.477 46.4582 131.988 44.7783 130.648C45.683 143.126 46.4245 161.61 45.6014 174.74C46.7081 172.223 47.63 169.628 48.3599 166.977C50.399 159.452 50.184 146.455 49.4276 135.096Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.3",
          d: "M49.4276 135.096C48.0142 133.477 46.4582 131.988 44.7783 130.648C45.683 143.126 46.4245 161.61 45.6014 174.74C46.7081 172.223 47.63 169.628 48.3599 166.977C50.399 159.452 50.184 146.455 49.4276 135.096Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M19.8489 210.032C19.886 210.032 16.5195 212.256 16.5195 212.256L7.13184 206.102L10.0979 203.648L19.8489 210.032Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.3",
          d: "M19.8489 210.032C19.886 210.032 16.5195 212.256 16.5195 212.256L7.13184 206.102L10.0979 203.648L19.8489 210.032Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M57.5695 113.12C57.5695 113.12 65.7707 147.893 66.349 164.508C67.0016 183.133 60.4985 227.07 60.4985 227.07H51.2665C51.2665 227.07 50.132 182.792 49.7242 165.828C49.2719 147.33 38.416 113.12 38.416 113.12H57.5695Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.1",
          d: "M57.5695 113.12C57.5695 113.12 65.7707 147.893 66.349 164.508C67.0016 183.133 60.4985 227.07 60.4985 227.07H51.2665C51.2665 227.07 50.132 182.792 49.7242 165.828C49.2719 147.33 38.416 113.12 38.416 113.12H57.5695Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M62.2704 223.4C62.3149 223.4 61.7513 227.225 61.7513 227.225H50.5247L50.2207 223.807L62.2704 223.4Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.3",
          d: "M62.2704 223.4C62.3149 223.4 61.7513 227.225 61.7513 227.225H50.5247L50.2207 223.807L62.2704 223.4Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M193.759 79.499C194.389 80.0921 194.886 80.5963 195.405 81.1598C195.924 81.7232 196.413 82.2719 196.888 82.8428C197.852 83.9772 198.756 85.1708 199.631 86.3719C201.379 88.7813 202.934 91.3249 204.281 93.9789L204.555 94.5202C204.689 94.7822 204.801 95.055 204.889 95.3357C205.068 95.8783 205.178 96.4413 205.215 97.0114C205.263 98.0166 205.125 99.0221 204.807 99.977C204.266 101.563 203.461 103.047 202.427 104.366C200.564 106.759 198.366 108.871 195.902 110.639L194.055 108.518C194.923 107.502 195.827 106.413 196.636 105.323C197.458 104.267 198.202 103.152 198.86 101.986C199.475 100.97 199.931 99.8643 200.21 98.7092C200.306 98.296 200.323 97.8685 200.262 97.4488C200.235 97.3076 200.19 97.1705 200.128 97.041C200.101 96.9841 200.068 96.9296 200.032 96.8779L199.795 96.4775C198.364 94.146 196.813 91.8915 195.145 89.7232C194.322 88.6333 193.44 87.5879 192.55 86.5573C192.112 86.0383 191.66 85.5341 191.208 85.03C190.755 84.5258 190.266 84.0216 189.873 83.6287L193.759 79.499Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M194.766 107.895L189.227 106.991L192.126 111.84C192.126 111.84 195.693 111.714 196.708 109.615L194.766 107.895Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M185.135 109.23L187.775 113.167L192.127 111.84L189.228 106.991L185.135 109.23Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M194.5 234.449C194.123 234.481 193.747 234.379 193.439 234.16C193.346 234.072 193.278 233.961 193.24 233.839C193.202 233.717 193.197 233.587 193.224 233.463C193.229 233.383 193.256 233.306 193.302 233.241C193.348 233.176 193.411 233.124 193.484 233.092C194.129 232.803 195.819 233.885 196.012 234.011C196.034 234.025 196.051 234.045 196.061 234.069C196.07 234.093 196.071 234.12 196.064 234.145C196.061 234.17 196.05 234.194 196.033 234.213C196.016 234.231 195.993 234.244 195.968 234.248C195.487 234.37 194.995 234.438 194.5 234.449ZM193.758 233.299C193.704 233.291 193.649 233.291 193.595 233.299C193.562 233.315 193.535 233.339 193.515 233.369C193.495 233.399 193.484 233.434 193.484 233.47C193.464 233.553 193.466 233.639 193.489 233.721C193.513 233.803 193.557 233.877 193.617 233.937C193.899 234.189 194.626 234.226 195.597 234.033C195.041 233.666 194.415 233.416 193.758 233.299Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M195.982 234.241H195.915C195.389 233.937 194.373 232.758 194.499 232.113C194.523 232.012 194.579 231.92 194.66 231.854C194.74 231.787 194.84 231.748 194.944 231.743C195.044 231.728 195.146 231.737 195.242 231.767C195.339 231.798 195.427 231.851 195.5 231.92C196.108 232.454 196.116 234.056 196.116 234.145C196.114 234.167 196.107 234.189 196.096 234.208C196.084 234.228 196.068 234.244 196.049 234.256L195.982 234.241ZM195.033 232.017H194.974C194.81 232.017 194.773 232.106 194.759 232.173C194.684 232.551 195.315 233.455 195.841 233.878C195.854 233.256 195.676 232.645 195.33 232.128C195.285 232.087 195.232 232.055 195.175 232.036C195.117 232.017 195.056 232.01 194.996 232.017H195.033Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M169.228 234.449C168.755 234.494 168.28 234.373 167.886 234.108C167.797 234.029 167.729 233.93 167.686 233.819C167.643 233.708 167.628 233.588 167.641 233.47C167.646 233.398 167.669 233.328 167.708 233.267C167.747 233.207 167.8 233.156 167.864 233.122C168.553 232.736 170.763 233.863 171.015 234.004C171.038 234.019 171.057 234.04 171.069 234.065C171.08 234.09 171.085 234.117 171.082 234.145C171.078 234.171 171.065 234.195 171.047 234.213C171.028 234.232 171.004 234.244 170.978 234.249C170.403 234.371 169.817 234.438 169.228 234.449ZM168.242 233.3C168.157 233.294 168.073 233.312 167.997 233.352C167.971 233.364 167.948 233.384 167.932 233.409C167.917 233.434 167.908 233.463 167.908 233.492C167.897 233.57 167.905 233.648 167.93 233.722C167.956 233.796 168 233.862 168.057 233.915C168.398 234.219 169.31 234.271 170.541 234.063C169.823 233.681 169.046 233.423 168.242 233.3Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M170.956 234.241H170.897C170.237 233.945 168.924 232.758 169.028 232.113C169.028 231.965 169.162 231.78 169.525 231.743C169.658 231.728 169.792 231.741 169.92 231.781C170.047 231.82 170.165 231.886 170.267 231.972C170.964 232.551 171.097 234.048 171.097 234.115C171.1 234.138 171.097 234.161 171.088 234.182C171.078 234.203 171.064 234.221 171.045 234.234C171.017 234.246 170.986 234.248 170.956 234.241ZM169.629 232.017H169.547C169.31 232.017 169.295 232.136 169.288 232.165C169.228 232.543 170.118 233.485 170.771 233.893C170.706 233.259 170.447 232.661 170.029 232.18C169.917 232.084 169.776 232.027 169.629 232.017Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M179.722 62.4536C179.507 65.8049 178.928 72.6111 181.501 74.4943C181.501 74.4943 181.034 77.9271 174.961 78.7278C168.287 79.5953 171.335 75.8289 171.335 75.8289C174.872 74.4795 174.42 71.7881 173.456 69.3266L179.722 62.4536Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M165.907 56.5297C165.871 56.5297 165.834 56.5218 165.801 56.5065C165.768 56.4911 165.738 56.4687 165.715 56.4407C165.503 56.1892 165.234 55.9911 164.932 55.8623C164.629 55.7335 164.3 55.6776 163.972 55.6993C163.937 55.7056 163.902 55.7048 163.867 55.6969C163.833 55.689 163.801 55.6742 163.772 55.6534C163.744 55.6326 163.72 55.6062 163.702 55.5759C163.684 55.5455 163.672 55.5118 163.668 55.4768C163.66 55.4071 163.679 55.3369 163.722 55.2814C163.765 55.2259 163.828 55.1895 163.898 55.1803C164.316 55.1449 164.737 55.2114 165.125 55.3741C165.512 55.5367 165.855 55.7908 166.122 56.1145C166.154 56.1531 166.175 56.2001 166.182 56.2499C166.188 56.2997 166.181 56.3504 166.16 56.3961C166.139 56.4418 166.105 56.4807 166.063 56.5083C166.021 56.5358 165.972 56.5509 165.922 56.5519L165.907 56.5297Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M164.75 59.8142C164.487 60.8776 164.08 61.9002 163.541 62.854C163.789 62.9872 164.062 63.0642 164.343 63.0796C164.624 63.095 164.904 63.0483 165.165 62.943L164.75 59.8142Z",
          fill: "#DE5753"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M165.047 58.9986C165.106 59.4435 164.921 59.829 164.631 59.8735C164.342 59.918 164.053 59.5769 164.001 59.1321C163.949 58.6872 164.127 58.3017 164.416 58.2646C164.706 58.2275 164.995 58.5241 165.047 58.9986Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M164.55 58.272L163.445 58.1015C163.445 58.1015 164.098 58.8652 164.55 58.272Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M177.067 234.123H171.506L171.135 221.259H176.696L177.067 234.123Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M202.315 234.123H196.754L194.967 221.259H200.528L202.315 234.123Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M196.413 233.5H202.657C202.763 233.499 202.866 233.536 202.947 233.606C203.027 233.676 203.08 233.772 203.094 233.878L203.836 238.823C203.849 238.948 203.836 239.074 203.798 239.193C203.759 239.312 203.696 239.422 203.612 239.515C203.528 239.609 203.425 239.683 203.31 239.733C203.195 239.784 203.071 239.81 202.946 239.809C200.773 239.772 199.72 239.646 196.977 239.646C195.286 239.646 192.817 239.817 190.488 239.817C188.16 239.817 188.034 237.511 189.005 237.303C193.358 236.369 194.048 235.079 195.508 233.841C195.763 233.629 196.082 233.509 196.413 233.5Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M171.321 233.5H177.557C177.664 233.498 177.768 233.536 177.85 233.605C177.932 233.675 177.986 233.772 178.002 233.878L178.743 238.823C178.757 238.948 178.744 239.074 178.705 239.193C178.667 239.312 178.603 239.422 178.519 239.515C178.435 239.609 178.333 239.683 178.218 239.733C178.103 239.784 177.979 239.81 177.853 239.809C175.681 239.772 174.628 239.646 171.884 239.646C170.194 239.646 166.694 239.817 164.365 239.817C162.037 239.817 161.911 237.511 162.882 237.303C167.235 236.369 168.948 235.079 170.416 233.841C170.671 233.629 170.989 233.509 171.321 233.5Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M171.135 221.259L171.328 227.895H176.889L176.696 221.259H171.135Z",
          fill: "#CE6F64"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M200.528 221.259H194.967L195.894 227.895H201.448L200.528 221.259Z",
          fill: "#CE6F64"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M179.796 55.5138C180.174 61.0152 180.448 63.3358 178.061 66.5017C174.464 71.2542 167.628 70.5202 165.611 65.2413C163.794 60.4888 163.483 52.296 168.54 49.4193C169.652 48.7818 170.909 48.4391 172.191 48.4236C173.474 48.4082 174.738 48.7205 175.866 49.331C176.994 49.9415 177.946 50.8299 178.634 51.912C179.322 52.994 179.722 54.2339 179.796 55.5138Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M182.999 60.6222C186.083 62.3423 188.375 58.1014 188.375 58.1014C188.375 58.1014 182.843 58.702 183.34 55.4101C183.992 51.0431 180.863 45.7345 173.018 46.4166C172.58 46.4537 172.165 46.5056 171.757 46.5723C170.936 46.1831 170.007 46.0826 169.122 46.2871C168.236 46.4917 167.445 46.9893 166.878 47.6993C164.653 47.8846 161.65 50.5389 163.69 54.0458C163.833 53.6429 164.054 53.2724 164.342 52.9559C164.513 55.0097 166.307 58.2719 168.546 58.4869C169.028 61.2969 167.16 64.5518 167.805 67.4878C168.761 71.7213 175.902 72.6778 175.902 72.6778C175.656 72.1491 175.564 71.5616 175.638 70.983C175.711 70.4044 175.947 69.8585 176.318 69.4081C181.167 71.6324 184.363 69.46 184.363 69.46C181.056 68.2292 182.057 66.0346 182.057 66.0346C183.199 66.5416 184.493 66.5861 185.667 66.1589C186.841 65.7316 187.804 64.8659 188.352 63.7436C187.254 63.7958 186.164 63.5288 185.214 62.9749C184.264 62.421 183.494 61.6039 182.999 60.6222Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M170.481 59.3322C170.494 59.8602 170.403 60.3855 170.212 60.878C170.021 61.3704 169.734 61.8202 169.369 62.2015C168.39 63.2172 167.189 62.5055 166.863 61.208C166.573 60.0365 166.737 58.1014 168.012 57.5676C168.293 57.4573 168.596 57.4189 168.896 57.4559C169.195 57.4929 169.48 57.6042 169.726 57.7795C169.971 57.9549 170.169 58.1888 170.301 58.4599C170.433 58.7311 170.495 59.0309 170.481 59.3322Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M175.102 110.587C175.102 110.587 176.51 147.183 179.862 168.67C182.561 186.034 194.552 226.604 194.552 226.604H202.13C202.13 226.604 195.879 187.42 194.507 170.256C191.037 126.816 200.046 117.489 191.541 108.444L175.102 110.587Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M181.434 122.16C181.434 122.16 178.008 121.567 176.006 128.092C176.747 140.451 178.015 156.852 179.862 168.67C180.27 171.302 180.892 174.475 181.656 177.952C180.21 157.074 181.434 122.16 181.434 122.16Z",
          fill: "#161F33"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M169.191 111.358C169.191 111.358 162.948 151.847 163.311 168.788C163.689 186.412 170.148 226.619 170.148 226.619H177.66C177.66 226.619 176.473 187.457 177.133 170.153C177.875 151.283 185.579 109.23 185.579 109.23L169.191 111.358Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M203.227 226.96H193.149L192.363 223.579L203.152 223.654L203.227 226.96Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.2",
          d: "M203.227 226.96H193.149L192.363 223.579L203.152 223.654L203.227 226.96Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M191.163 74.5018C194.062 74.7835 198.467 83.0207 198.467 83.0207L191.148 88.6333C191.148 88.6333 185.09 83.3173 185.809 80.3294C186.558 77.2228 188.382 74.2423 191.163 74.5018Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.1",
          d: "M191.163 74.5018C194.062 74.7835 198.467 83.0207 198.467 83.0207L191.148 88.6333C191.148 88.6333 185.09 83.3173 185.809 80.3294C186.558 77.2228 188.382 74.2423 191.163 74.5018Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M188.975 78.0458C188.236 77.8466 187.471 77.7616 186.706 77.7937C186.317 78.6043 186.016 79.4544 185.809 80.3294C185.067 83.295 191.148 88.6333 191.148 88.6333L191.689 88.2181L188.975 78.0458Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.3",
          d: "M188.975 78.0458C188.236 77.8466 187.471 77.7616 186.706 77.7937C186.317 78.6043 186.016 79.4544 185.809 80.3294C185.067 83.295 191.148 88.6333 191.148 88.6333L191.689 88.2181L188.975 78.0458Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M166.708 85.9567C164.594 91.3023 162.37 96.737 160.597 102.097C160.479 102.438 160.382 102.765 160.279 103.098L160.027 103.921C159.958 104.164 159.958 104.42 160.027 104.663C160.445 105.59 161.109 106.385 161.947 106.961C164.164 108.552 166.58 109.845 169.132 110.809L168.465 113.538C165.325 113.124 162.288 112.133 159.507 110.616C157.796 109.702 156.403 108.291 155.511 106.568C154.998 105.467 154.821 104.24 154.999 103.039C155.016 102.892 155.041 102.746 155.073 102.602L155.147 102.29L155.273 101.727C155.362 101.349 155.451 100.985 155.548 100.615C156.289 97.6489 157.238 94.8315 158.239 92.0363C159.24 89.2412 160.286 86.4831 161.465 83.7324L166.708 85.9567Z",
          fill: "#E4897B"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M162.207 78.4534C162.207 78.4534 159.7 79.7212 169.192 111.358L191.571 108.436C189.999 99.3763 189.257 93.7637 191.163 74.5016C187.954 74.2718 184.732 74.2718 181.523 74.5016C178.107 74.7002 174.709 75.1463 171.357 75.8362C167.064 76.7926 162.207 78.4534 162.207 78.4534Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.1",
          d: "M162.207 78.4534C162.207 78.4534 159.7 79.7212 169.192 111.358L191.571 108.436C189.999 99.3763 189.257 93.7637 191.163 74.5016C187.954 74.2718 184.732 74.2718 181.523 74.5016C178.107 74.7002 174.709 75.1463 171.357 75.8362C167.064 76.7926 162.207 78.4534 162.207 78.4534Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M191.733 107.08L193.016 108.941C193.112 109.089 192.949 109.267 192.697 109.304L169.228 112.374C169.028 112.374 168.842 112.322 168.813 112.196L168.353 110.216C168.316 110.083 168.479 109.942 168.701 109.912L191.362 106.946C191.43 106.935 191.5 106.942 191.565 106.965C191.63 106.989 191.688 107.028 191.733 107.08Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.2",
          d: "M191.733 107.08L193.016 108.941C193.112 109.089 192.949 109.267 192.697 109.304L169.228 112.374C169.028 112.374 168.842 112.322 168.813 112.196L168.353 110.216C168.316 110.083 168.479 109.942 168.701 109.912L191.362 106.946C191.43 106.935 191.5 106.942 191.565 106.965C191.63 106.989 191.688 107.028 191.733 107.08Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M189.019 110.009L189.627 109.927C189.746 109.927 189.828 109.838 189.813 109.764L189.19 107.199C189.166 107.155 189.128 107.121 189.082 107.102C189.036 107.083 188.985 107.08 188.938 107.095L188.33 107.169C188.204 107.169 188.122 107.258 188.144 107.339L188.767 109.897C188.782 109.979 188.901 110.023 189.019 110.009Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M174.308 111.907L174.916 111.825C175.035 111.825 175.124 111.736 175.102 111.662L174.479 109.097C174.454 109.053 174.417 109.019 174.371 108.999C174.326 108.979 174.275 108.974 174.227 108.985L173.618 109.067C173.5 109.067 173.411 109.156 173.433 109.23L174.056 111.795C174.071 111.907 174.189 111.951 174.308 111.907Z",
          fill: "#263238"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M163.252 89.1893C163.867 92.0512 164.735 95.6767 166.003 100.266L166.277 88.6332L163.252 89.1893Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.3",
          d: "M163.252 89.1893C163.867 92.0512 164.735 95.6767 166.003 100.266L166.277 88.6332L163.252 89.1893Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M162.206 78.4535C159.426 79.5731 157.016 89.0855 157.016 89.0855L166.581 93.7416C166.581 93.7416 171.201 82.1087 169.132 79.84C167.063 77.5712 165.41 77.1708 162.206 78.4535Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.1",
          d: "M162.206 78.4535C159.426 79.5731 157.016 89.0855 157.016 89.0855L166.581 93.7416C166.581 93.7416 171.201 82.1087 169.132 79.84C167.063 77.5712 165.41 77.1708 162.206 78.4535Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M178.943 226.96H168.866L168.08 223.579L179.299 223.654L178.943 226.96Z",
          fill: "#336EA8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.2",
          d: "M178.943 226.96H168.866L168.08 223.579L179.299 223.654L178.943 226.96Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M169.288 109.89L168.48 109.556C168.281 109.475 168.065 109.449 167.852 109.478C167.64 109.508 167.439 109.594 167.27 109.726C167.102 109.859 166.971 110.034 166.892 110.233C166.813 110.432 166.787 110.649 166.819 110.861L167.405 114.724C167.433 114.917 167.503 115.102 167.612 115.265C167.72 115.427 167.863 115.564 168.03 115.665C168.198 115.765 168.385 115.828 168.58 115.847C168.774 115.866 168.971 115.842 169.155 115.777C169.449 115.67 169.724 115.517 169.97 115.324C170.238 115.102 170.451 114.82 170.59 114.5C170.729 114.181 170.791 113.834 170.771 113.486L170.69 111.884C170.675 111.451 170.535 111.032 170.286 110.678C170.037 110.324 169.69 110.05 169.288 109.89Z",
          fill: "#E4897B"
        }
      )
    ]
  }
);
export {
  i as NoCouponsIcon
};
